// extracted by mini-css-extract-plugin
export var menuIcon = "_m9-0";
export var menuIconInline = "_m9-1";